import * as z from "zod";

export const testTemplateApiSchema = z.object({
  campaign_id: z.number().optional(),
  broadcast_id: z.number().optional(),
  message_id: z.number().optional(),
});
